import { FC, Fragment, useMemo } from "react";
import { CMSStaticSection } from "../models";
import { Card } from "antd";
import React from "react";
import { JCMSImage } from "../JCMSImage";
import { JHTML } from "../JHTML";
import './JCMSCard.scss';
import { JBadgeList } from "../JBadgeList";


export type JCMSCardProps = CMSStaticSection.Card & {
    onClick?: () => void,
    title?: CMSStaticSection.Card['title'],
    className?: string,
    ghostTitle?: boolean;
    ghostSubTitle?: boolean;
    ghostText?: boolean;
}

export const JCMSCard: FC<JCMSCardProps> = props => {
    if(props.enabled === false) return <></>

    const imagePosition: CMSStaticSection.ImagePosition = useMemo(() => {
        return props?.options?.imagePosition || 'cover'
    }, [props?.options?.imagePosition])

    const imagePadding: CMSStaticSection.ImagePadding = useMemo(() => {
        return props?.options?.imagePadding || 'none'
    }, [props?.options?.imagePadding])



    const title = useMemo(() => (
        props.title || (props.ghostTitle === false ? '' : '&#8203;')
    ), [props.title, props.ghostTitle])

    const subTitle = useMemo(() => (
        props.subTitle || (props.ghostSubTitle ? '&#8203;' : '')
    ), [props.subTitle, props.ghostSubTitle])

    const text = useMemo(() => (
        props.text || (props.ghostText ? '&#8203;' : '')
    ), [props.text, props.ghostText])


    const mainClasses = useMemo(() => {
        const classes = [
            'jcms-card',
            `jcms-card-image-position-${imagePosition}`,
            `jcms-card-image-padding-${imagePadding}`
        ]
        return classes.join(' ')
    }, [imagePosition, imagePadding])

    function onClick() {
        if (props.onClick) {
            props.onClick()
        }
    }

    const walletBadge = props?.options?.walletBadge
    const headerContent = props?.options?.headerContent
    const contentImage = props?.options?.contentImage

    return (
        <div className={props.className ? props.className : 'jcms-card-standard'}>
            <div className={mainClasses}>
                <Card
                    onClick={onClick}
                    hoverable={!!props.onClick}
                    cover={
                        <Fragment>
                            {
                                headerContent && (
                                    <div className="jcms-card-header-content" style={{
                                        backgroundColor: headerContent.backgroundColor,
                                        color: headerContent.color
                                    }}>
                                        {headerContent.text}
                                    </div>
                                )
                            }
                            {
                                walletBadge && (
                                    <JBadgeList items={walletBadge} />
                                )
                            }
                            <JCMSImage image={props.image} usePlaceholder/>

                        </Fragment>
                    }
                >
                    <Card.Meta
                        title={
                            <Fragment>
                                {
                                    subTitle && (
                                        <JHTML.SubTitle html={subTitle} />
                                    )
                                }
                                {

                                    title && (
                                        <JHTML.Text html={title} />
                                    )
                                }
                            </Fragment>

                        }
                        description={
                            <Fragment>
                                <div className={`jcms-card-${contentImage ? 'with-' : 'without-'}content-image`}>
                                    {
                                        contentImage && (
                                            <div className="jcms-card-content-image">
                                                <JCMSImage image={[{ src: contentImage }]} />
                                            </div>
                                        )
                                    }
                                    {
                                        text && (
                                            <div>
                                                <JHTML.Text html={text} />
                                            </div>
                                        )
                                    }
                                </div>
                            </Fragment>
                        }
                    />
                </Card>
            </div>

        </div>
    )
}

